export default __webpack_public_path__ + "static/AppMoneyWalkie10-de64860b28314522e68be4f375e63906.png";